import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailNote } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailNote";
import { DetailSectionHeader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailSectionHeader";

const PageResources = Resources.PortfolioDetail;

type Props = {
	data: ClientPropertyVehicleDetailResponseDTO;
};

export const AutoMotoBasicInfoDetails: FC<Props> = ({ data }) => {
	const { t } = useResource();
	const theme = useTheme();

	if (!data.description) {
		return null;
	}

	return (
		<>
			<DetailSectionHeader
				title={t(Resources.DataCard.BasicInfo.additionalInfo)}
			/>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailNote
					label={t(PageResources.Property.AdditionalDescription)}
					text={data.description}
				/>
			</Stack>
		</>
	);
};
